
import * as echarts from 'echarts';
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class EchartsComponent extends Vue {
  getChart1Data() {
    const renewData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '已续费' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '未续费' },
    ];
    const communicateData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '考虑中' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '暂不续费' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '续签成功' },
    ];
    const reasonData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '建联 从未建联' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '效果 团购订单少' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '效果 电话客资少' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '市场 架道竞争影响' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '效果客有效性差' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '其他 自身资金紊张' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '其他 合伙人/家人不同意' },
    ];
    const continuedChargingData = [
      { value: Math.floor(Math.random() * 1000) + 1, name: '考虑中' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '暂不续费' },
      { value: Math.floor(Math.random() * 1000) + 1, name: '续签成功' },
    ];
    const renewOption = {
      title: {
        top: '10%',
        text: '续费情况',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },
      series: [
        {
          name: '续费情况',
          type: 'pie',
          radius: ['20%', '40%'],
          center: ['50%', '55%'], // 第一个值是水平居中，第二个值控制垂直位置
          data: renewData,
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    const communicateOption = {
      title: {
        top: '10%',
        text: '沟通情况',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },
      series: [
        {
          name: '沟通情况',
          type: 'pie',
          radius: '40%',
          center: ['50%', '55%'], // 第一个值是水平居中，第二个值控制垂直位置
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          data: communicateData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    const reasonOption = {
      title: {
        top: '10%',
        text: '暂不续费原因',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },

      series: [
        {
          name: '暂不续费原因',
          type: 'pie',
          radius: '40%',
          center: ['50%', '55%'], // 第一个值是水平居中，第二个值控制垂直位置
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          data: reasonData,

          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    const continuedChargingOption = {
      title: {
        top: '10%',
        text: '续充占比',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        orient: 'vertical',
        right: 10,
        itemGap: 5, // 默认 10
      },
      series: [
        {
          name: '续充占比',
          type: 'pie',
          radius: '40%',
          label: {
            formatter: '{d}%',
            rich: {
              time: {
                fontSize: 10,
                color: '#999',
              },
              name: {
                fontSize: 10,
                color: '#999',
              },
            },
          },
          data: continuedChargingData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    };
    this.echartsInit('renew', renewOption);
    this.echartsInit('communicate', communicateOption);
    this.echartsInit('reason', reasonOption);
    this.echartsInit('ContinuedCharging', continuedChargingOption);
  }

  echartsInit(id: string, option: any) {
    const chart = echarts.init(document.getElementById(id));
    setTimeout(() => {
      chart && chart.setOption(option);
    }, 1000);
  }
  handValue: string | undefined = undefined;
  handleChange(value?: string) {
    this.handValue = value;
    this.getChart1Data();
  }
}

